<template>
	<Cascader 
		:disabled="disabled"
		ref="cascader"
		filterable 
		transfer
		:data="list" 
		:render-format="format"
		@on-change="change" 
		:value="handleCode(value)">
	</Cascader>
</template>
<script>
import jobList from '@/assets/js/job.json' // 只包含1-5类。 jobAll.json包含1-6类。
import jobListGs from '@/assets/js/jobGs.json' // 只包含1-5类。 jobAll.json包含1-6类。

export default {
	props:{
		value:String,
		productCode:{
			type:String,
			default:''
		},
		disabled:{
			type: Boolean,
			default: false
		}
	},
	data(){
		return {
			jobList:[],
			list:[]
		}
	},
	created(){
		if (this.productCode=='GSCGZZRX'||this.productCode=='GSCGZZRXPC'||this.productCode=='GSCGZZRXPCUPD'||this.productCode=='GSCGZZRXPCUPDA') { //国寿企业雇主责任险
			this.jobList = jobListGs
		} else { // 默认平安企业雇主责任险
			this.jobList = jobList
		}
		this.list=this.jobList.map(item=>{
			return {
				value:item.value,
				label:item.label,
				loading: false,
				children:item.children
			}
		})
		// console.log(this.list)
	},
	methods:{
		// 处理成数组
		handleCode (code){
			if(code){
				let codeArray = []
				if (this.productCode=='GSCGZZRX'||this.productCode=='GSCGZZRXPC'||this.productCode=='GSCGZZRXPCUPD'||this.productCode=='GSCGZZRXPCUPDA'){
					codeArray.push(code.substr(0,2))
					codeArray.push(code.substr(0,4))
				}else{
					codeArray.push(code.substr(0,2))
					codeArray.push(code.substr(0,6))
				}
				codeArray.push(code)
				console.log(codeArray)
				return codeArray
			}
		},
		// 选择
		change (code, val) {
			let data = val[val.length-1]
			if (data) {
				if (data.isRefuse==1) {
					this.alert('当前所选职业不符合投保条件');
					this.$refs.cascader.clearSelect()
				} else {
					this.$emit('change',val.length>0?val[val.length-1]:{
						value:'',
						category:''
					});
				}
			} else {
				this.$emit('change',{
					value:'',
					category:''
				});
			}
		},
		// 展示格式化
		format (labels, selectedData) {
			const index = labels.length - 1;
			return labels[index];
		},
		// 动态加载选项
		loadData (item, callback) {
			item.loading=true;
			let newItem=this.jobList.find(newItem=>{
				return newItem.value==item.value;
			})
			item.children=newItem.children;
			item.loading=false;
			callback();
		}
	}
}
</script>


// WEBPACK FOOTER //
// src/components/common/SelectJob.vue